<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense 
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
      <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
    <template v-slot:top>
      <div class="d-flex justify-end my-4 mr-6">
        <v-btn
          icon
          color="warning"
          class="mb-2 ml-2"
          @click="getData"
          :loading="loading"
          :disabled="loading"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
      </template>
      <template v-slot:body-prepend>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Nama Merchant"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('merchant_name')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.aggregator_name"
              type="text"
              label="Nama Aggregator"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('aggregator_name')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('mid')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.email"
              type="text"
              label="Email"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('email')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.subject"
              type="text"
              label="Subject"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('subject')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenuBDate"
              v-model="dateMenuBDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="bdateFormatted"
                  label="Broadcast Date"
                  v-bind="attrs"
                  @blur="search.created_at = parseDate(bdateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                  clearable
                  @click:clear="clearFilterData('broadcast_date')"
                />
              </template>
              <v-date-picker
                v-model="search.broadcast_date"
                no-title
                scrollable
                @input="dateMenuBDate = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenuBDate = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.status"
              :items="itemsStatus"
              label="Status"
              item-text="text"
              item-value="value"
              @change="searchFilter"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenuRDate"
              v-model="dateMenuRDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="rdateFormatted"
                  label="Resend Date"
                  v-bind="attrs"
                  @blur="search.resend_date = parseDate(rdateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                  clearable
                  @click:clear="clearFilterData('resend_date')"
                />
              </template>
              <v-date-picker
                v-model="search.resend_date"
                no-title
                scrollable
                @input="dateMenuRDate = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenuRDate = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.resend_counter"
              type="text"
              label="Resend Counter"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('resend_counter')"
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:action="{ item }">
        <td>
            <v-btn
              color="warning"
              x-small
              v-if="!item.disabled"
              @click="openDialogResend(item)"
              >Resend</v-btn
            >
          </td>
      </template>
      </TableView>
    <v-dialog v-model="dialogResend" width="500" persistent>
      <v-card>
        <v-card-title> Are you sure want to resend broadcast ? </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="() => (dialogResend = false)">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="resend"
            :disabled="loading"
            :loading="loading"
          >
            Resend
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import broadcastLogMixin from '../../components/broadcast-management/broadcast-log/broadcastLogMixin';

export default {
  mixins: [broadcastLogMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
